import PropTypes from 'prop-types';

export const DealModal = ({ modal = {} }) => {
  //console.log('modal.props: ' + JSON.stringify(modal));
  const deal = modal?.deal;
  if (!deal) {
    return null;
  }
  return (
    <div id='dealModal' className="modal fade bd-example-modal-lg" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-body">
            <div className='container-fluid'>
              <div className="row">
                <div className="col-lg">
                  <img className ='modal-img' src={deal.image_url} alt="Product Image" />
                  <div className="ribbon top">
                    <div className="ribbon-text">{`${deal.percent_discount  }% Off`}</div>
                  </div>
                </div>
                <div className="col-lg">
                  <div className="row">
                    <div className = 'col'>
                      <p className='h6 text-primary'>{deal.title}</p>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">col</div>
                    <div className="col">col</div>
                    <div className="w-100"></div>
                    <div className="col">col</div>
                    <div className="col">col</div>
                  </div>
                  <div className="row mt-auto">
                    <div className="col">
                                    One of three columns
                    </div>
                    <div className="col">
                                    One of three columns
                    </div>
                    <div className="col">
                                    One of three columns
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

DealModal.propTypes = {
  modal: PropTypes.shape({
    deal: PropTypes.shape({
      image_url: PropTypes.string,
      percent_discount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      title: PropTypes.string,
    }),
  }),
};
